/* eslint-disable camelcase */
import { Component, OnInit, OnDestroy, Inject, } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../login/login.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { AutomatedTest, AutomatedTestArea, AutomatedTestParameter, AutomatedTestStatus } from '../models/ast-element.model';

@AutoUnsubscribe()
@Component({
    selector: 'automatedTestingModal',
    templateUrl: './automated-testing-modal.component.html',
    styleUrls: ['./automated-testing-modal.component.css']

    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})



export class AutomatedTestingModalComponent implements OnInit, OnDestroy {



    thisDialogRef: MatDialogRef<AutomatedTestingModalComponent>;

    // testAreas: string[];
    // testArea = '';

    // testSubAreas: string[];
    // testSubArea = '';

    // elementAreas: string[];
    // elementArea = '';

    // elementSubAreas: string[];
    // elementSubArea = '';

    // tests: AutomatedTest[] = [];
    // test: AutomatedTest;


    // testSteps: AutomatedTestStep[] = [];

    // allElements: Element[];
    // elements: Element[];
    // // element: Element;

    // // elementActions: ElementAction[];

    // identifiers: string[];

    // actions: string[];

    // action = '';
    // controlName = '';
    // identifier = '';
    // dataInput = '';
    // testText = '';
    // testData = '';

    // elementListItems: DataSource[] = [];
    // allElementsListItems: DataSource[] = [];

    // showTests = true;
    // showTestSteps = false;

    action: string;
    title: string;

    editTest = false;
    addTest = false;
    addSubTest = false;

    test: AutomatedTest;
    tests: AutomatedTest[] = [];
    testsInArea: AutomatedTest[] = [];
    // selectedTest: AutomatedTest;

    testAreas: string[] = [];
    testArea = '';

    allAreas: AutomatedTestArea[] = [];
    distinctAreas: AutomatedTestArea[] = [];
    distinctTestAreas: AutomatedTestArea[] = [];

    selectedArea: string; // AutomatedTestArea;

    testSubAreas: string[] = [];
    testSubArea = '';

    testOrder: number;
    stepOrder: number;

    insertStep = false;
    insertStepType = '';

    addStep = false;
    addStepType = '';
    addParameter = false;
    editParameter = false;

    parameterName: string;
    parameterValue: string;


    parameter: AutomatedTestParameter;

    copyTestId: number;
    copyTest = false;
    parentTest_ID: number;
    inDebugMode = true;

    // addStepComment = false;
    // editStepComment = false;
    // step: AutomatedTestStep;


    constructor(
        automatedTestingModalDialogRef: MatDialogRef<AutomatedTestingModalComponent>,
        private reportService: ReportingService,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private loginService: LoginService,
        private dialog: MatDialog,

    ) {

        this.inDebugMode = false;

        this.thisDialogRef = automatedTestingModalDialogRef;

        if (data.parameter == null || data.parameter == undefined) {
            this.parameter = new AutomatedTestParameter();
            this.parameterName = '';
            this.parameterValue = '';
        }
        else {
            this.parameter = data.parameter;
            this.parameterName = this.parameter.ParameterName;
            this.parameterValue = this.parameter.ParameterValue;
        }

        this.title = data.title;



        // console.log(this.parameter);


        this.testAreas = data.testAreas;
        this.testSubAreas = data.testSubAreas;
        this.testOrder = data.testOrder;
        this.stepOrder = data.stepOrder;
        this.parentTest_ID = data.parentTest_ID;
        this.tests = data.tests.filter(t => t.Test_ID != this.parentTest_ID); // we want to exclude the test we are coming from
        // console.log(this.tests);
        // console.log(this.parentTest_ID);

        this.allAreas = data.allAreas;
        // this.step = data.step;

        this.distinctAreas = this.allAreas.filter(
            (thing, i, arr) => arr.findIndex(t => t.AreaName === thing.AreaName) === i
        );

        if (this.data.action == 'copyTest') {
            this.copyTest = true;
            this.copyTestId = data.copyTestId;
        } else {
            this.copyTest = false;
            this.copyTestId = 0;
        }

        if (this.data.action == 'editTest'  || this.data.action == 'addParameter' || this.data.action == 'editParameter') {
            this.test = data.test;
            this.selectedArea = this.test.TestAreaName;
            this.testSubArea = this.test.TestSubAreaName;
            this.testArea = this.test.TestAreaName;
        }

        if (this.data.action == 'editTest') {
            this.editTest = true;
        }

        const tst = this.tests.filter(t => t.Test_ID != this.parentTest_ID);
        // console.log(tst);
    }

    ngOnInit() {

        // console.log(this.data);

        for (let x = 0; x < this.distinctAreas.length; x++) {
            // we only want top level portals for tests
            // if (this.distinctAreas[x].AreaName == 'Classroom360' || this.distinctAreas[x].AreaName == 'Student360' || this.distinctAreas[x].AreaName == 'Practice360' || this.distinctAreas[x].AreaName == 'Portal') {
            //     this.distinctTestAreas.push(this.distinctAreas[x]);
            // }

            this.distinctTestAreas.push(this.distinctAreas[x]);
        }

        if (this.data.action == 'editTest' || this.data.action == 'addParameter' || this.data.action == 'editParameter') {
            // console.log(this.data.action);
        } else {
            this.test = new AutomatedTest();
            this.test.Test_ID = 0;

            this.test.InProgress = true;
            this.test.ReadyForReview = false;
            this.test.Approved = false;
            this.test.IsObsolete = false;
            this.test.SelectedStatus = AutomatedTestStatus.InProgress;
        }


        if (this.data.action == 'copyTest') {
            this.test.CopyTestId = this.copyTestId;
        }

        if (this.data.action == 'addTest' || this.data.action == 'copyTest') {
            this.addTest = true;
            this.test.TestOrder = this.testOrder;

            // // console.log(this.testOrder);
        }

        if (this.data.action == 'addSubTest') {
            this.addSubTest = true;
            // this.test.TestOrder = this.testOrder;

            // // console.log(this.tests);
        }

        if (this.data.action == 'insertStep') {
            this.insertStep = true;
            this.addSubTest = true;
            this.insertStepType = 'Regular Step';
            // this.test.TestOrder = this.testOrder;

        }

        if (this.data.action == 'addParameter') {
            this.addParameter = true;
        }

        if (this.data.action == 'editParameter') {
            this.editParameter = true;
        }

        // if (this.data.action == 'editStepComment') {
        //     this.editStepComment = true;
        // }

        // if (this.data.action == 'addStepComment') {
        //     this.addStepComment = true;
        // }


        // console.log(this.insertStepType);

        // for (let x = 0; x < this.allAreas.length; x++) {
        //     if (this.allAreas[x].AreaName == this.selectedArea && this.allAreas[x].SubAreaName == this.testSubArea) {
        //         this.test.TestArea_ID = this.allAreas[x].Area_ID;
        //     }
        // }


        if (this.test.IsSubTestOnly == null || this.test.IsSubTestOnly == undefined) {
            this.test.IsSubTestOnly = false;
        }

        // console.log(this.test);
        // console.log(this.parameter);




    }

    ngOnDestroy() { }



    toggleStepType() {

        // console.log('BEFORE:');
        // console.log(this.insertStepType);
        if (this.insertStepType == 'Regular Step') {
            this.insertStepType = 'Shared Test';
        } else {
            this.insertStepType = 'Regular Step';
        }

        // console.log('AFTER:');
        // console.log(this.insertStepType);
    }

    saveClick() {
        if (this.addParameter || this.editParameter) {

            // Parameter_ID: number;
            // ParameterName: string;
            // ParameterValue: string;

            // console.log('HERE!!!!');

            if (this.parameter.ParameterName == null || this.parameter.ParameterName == undefined || this.parameter.ParameterName  == '') {
                // doing this until I wire up required checks
                return;
            }

            if (this.parameter.ParameterValue == null || this.parameter.ParameterValue == undefined) {
                this.parameter.ParameterValue  = '';
            }


            // console.log(this.parameter);

            this.test.Parameter = this.parameter;

            this.reportService.saveAutomatedTestParameter(this.test.Test_ID, this.parameter).subscribe(results => {
                // console.log(results);

                // if (this.test.Parameter.ID == 0) {
                //     this.test.Parameter.ID = results;
                // }
                this.thisDialogRef.close('addParameter');
            });

           // this.thisDialogRef.close(this.test);

        } else {

            this.test.TestSubAreaName = this.testSubArea;
            this.test.TestAreaName = this.testArea; // ??

            if (this.inDebugMode) {
                console.log(this.test);
                console.log(this.testArea);
                console.log(this.testSubArea);
                console.log(this.selectedArea);
                console.table(this.allAreas);
            }


            for (let x = 0; x < this.allAreas.length; x++) {
                if (this.allAreas[x].AreaName == this.selectedArea && this.allAreas[x].SubAreaName == this.testSubArea) {
                    this.test.TestArea_ID = this.allAreas[x].Area_ID;
                }
            }


            this.reportService.saveAutomatedTest(this.test.Test_ID, this.test).subscribe(results => {
                // console.log(results);

                if (this.test.Test_ID == 0) {
                    this.test.Test_ID = results;
                }
                this.thisDialogRef.close(this.test);
            });

        }





    }


    closeClick() {
        this.thisDialogRef.close();
    }

    okClick() {
        // console.log(this.insertStep);
        // console.log(this.insertStepType);
        // console.log(this.addStepComment);
        // console.log(this.editStepComment);

        // if (this.addStepComment || this.editStepComment) {
        //     console.log(this.step);
        //     this.thisDialogRef.close(this.step);
        //     return;
        // }

        this.test.IsInsertedStep = false;
        if (this.insertStep && this.insertStepType == 'Regular Step') {
            this.thisDialogRef.close(this.insertStepType);
        } else {

            if (this.insertStep && this.insertStepType == 'Shared Test') {
                this.test.IsInsertedStep = true;
            }

            if (this.inDebugMode) {
                console.log(this.test);
            }
            // console.log(this.test);
            this.thisDialogRef.close(this.test);
        }
    }

    testAreaChanged() {

        // console.log(this.test);
        // console.log(this.selectedArea);


        this.testSubAreas = [];
        for (let x = 0; x < this.allAreas.length; x++) {
            if (this.allAreas[x].AreaName == this.selectedArea) {
                this.testSubAreas.push(this.allAreas[x].SubAreaName);
            }
        }
        // // console.log(this.tests);

        this.testsInArea = [];
        for (let x = 0; x < this.tests.length; x++) {
            this.testsInArea.push(this.tests[x]);
            // if (this.tests[x].TestAreaName == this.testArea && this.tests[x].TestSubAreaName == this.testSubArea) {
            //   this.testsInArea.push(this.tests[x]);
            // }
        }


    }

    testSubAreaChanged(event: any) {
        this.testsInArea = [];
        // // console.log(event);
        // console.table(this.tests);
        for (let x = 0; x < this.tests.length; x++) {
            // // console.log(this.testArea);
            // // console.log(this.testSubArea);

            if (this.tests[x].TestAreaName == this.testArea && this.tests[x].TestSubAreaName == this.testSubArea) {
                this.testsInArea.push(this.tests[x]);
            }
        }
    }

    testChanged() {

    }

    setTestArea(area: AutomatedTestArea) {
        // // console.log(area);
        this.testArea = area.AreaName;
        // // console.log(this.testArea);
    }

    setTestSubArea(subarea: string) {
        // // console.log(subarea);
        this.testSubArea = subarea;
    }

    copyTestClick() {

    }

    testStatusChange(theTest: AutomatedTest, event: number) {

        theTest.InProgress = false;
        theTest.ReadyForReview = false;
        theTest.Approved  = false;
        theTest.IsObsolete = false;
        if (event == AutomatedTestStatus.InProgress) {
            theTest.InProgress  = true;
        }
        if (event == AutomatedTestStatus.ReadyForReview) {
            theTest.ReadyForReview  = true;
        }
        if (event == AutomatedTestStatus.Approved) {
            theTest.Approved  = true;
        }
        if (event == AutomatedTestStatus.IsObsolete) {
            theTest.IsObsolete  = true;
        }

        // console.log(theTest);
        // console.log(event);

    }




}
